__webpack_require__.p = "https://static-website.assets.paypo.pl/_next/";